import { appType } from "@/main"
import { Uploader } from 'vant'
export default function useVant(app: appType) {
    app.use(
        Uploader
    )
}